const Images = {
  AnitsBanner: "/advertisements/banner/anits-banner.jpg",
  ChcBanner: "/advertisements/banner/chc-banner.jpg",
  GietBanner: "/advertisements/banner/giet-banner.jpg",
  LendiBanner: "/advertisements/banner/lendi-banner.jpg",
  SrkBanner: "/advertisements/banner/srk-banner.jpg",
  AnitsBillboard: "/advertisements/billboard/anits-billboard.jpg",
  ChcBillboard: "/advertisements/billboard/chc-billboard.jpg",
  GietBillboard: "/advertisements/billboard/giet-billboard.jpg",
  LendiBillboard: "/advertisements/billboard/lendi-billboard.jpg",
  SrkBillboard: "/advertisements/billboard/srk-billboard.jpg",
  AnitsCard: "/advertisements/card/anits-card.jpg",
  ChcCard: "/advertisements/card/chc-card.jpg",
  GietCard: "/advertisements/card/giet-card.jpg",
  LendiCard: "/advertisements/card/lendi-card.jpg",
  SrkCard: "/advertisements/card/srk-card.jpg",
  Logo: "/logo/crlogosm.png",
};

export default Images;
